/**
 * Ключи намерения с rid (D-064): один и тот же RefKey в двух базах — два
 * разных черновика и две разные операции. rid нормализуется к нижнему
 * регистру: GUID из адреса и из ответа службы пишутся по-разному.
 */
export const normalizeRid = (resourceId: string): string => resourceId.trim().toLowerCase()

/** Ключ принадлежит этому ресурсу. */
export const ownedBy = (key: string, resourceId: string): boolean => key.startsWith(`${normalizeRid(resourceId)}|`)
